<head>

<script src="https://unpkg.com/vue"></script>
<script src="https://unpkg.com/vue-cal"></script>
<link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">
</head>
<template>
  <br />
  <a-card title="Gerar Laudo">
    <div class="row">
      <label>Consultar Paciente</label>
      <div class="col-md-6 d-flex justify-content-left">
        <a-tooltip placement="top" title="Informe o nome, CPF ou RG Militar do Beneficiário" arrow-point-at-center>
          <a-auto-complete v-model:value="pacienteSelecionado.nome" class="form-control" :disabled="encontrado" @search="pesquisarDadosMilitarPeloNomeOuRg">
            <template v-slot:dataSource>
              <a-select-option v-for="item in pacientes" :key="item.nome" @click="onSelect(item)"> {{ item.cpf }} - {{ item.nome }} {{ item.rgMilitar }} </a-select-option>
            </template>
          </a-auto-complete>
        </a-tooltip>
        <a-tooltip placement="top" title="Limpar Consulta" arrow-point-at-center>
          <button @click="limpar()" style="margin-left: 4px" class="btn btn-icon-button" type="button"><i class="fa fa-eraser"></i></button>
        </a-tooltip>
      </div>
    </div>
  </a-card>
  <br />
  <a-card v-if="encontrado">
    <PageDadosMilitar v-model:dadosMilitar="pacienteSelecionado" />
  </a-card>
  <br />
  <a-card v-if="encontrado">
    <fieldset style="height: 100%">
      <legend style="width: 160px">Laudos</legend>
      <component v-bind:is="GerarDocumento" :paciente="pacienteSelecionado"></component>
    </fieldset>
  </a-card>
</template>

<script>
import PageDadosMilitar from '@/components/pages/PageDadosMilitar';
import { getPaciente } from '@/components/service/pacienteService';
import GerarDocumento from '@/components/pages/pages-atendimento/GerarDocumento';
export default {
  name: 'PageProntuarioCSIPM',
  components: {
    PageDadosMilitar,
    GerarDocumento,
  },

  setup() {
    return {};
  },
  data() {
    return {
      encontrado: false,
      pacientes: [],
      pacienteSelecionado: { posto: { nome: '' }, lotacao: { sigla: '' } },
      PageDadosMilitar: PageDadosMilitar,
      GerarDocumento: GerarDocumento,
    };
  },

  methods: {
    async pesquisarDadosMilitarPeloNomeOuRg(value) {
      if (value.length > 3) {
        await getPaciente({ any: value }).then((r) => {
          this.pacientes = r.data.pacientes;
        });
      } else {
        this.pacientes = [];
      }
    },
    limpar() {
      this.pacienteSelecionado = { posto: { nome: '' }, lotacao: { sigla: '' } };
      this.pacientes = [];
      this.encontrado = false;
    },

    onSelect(value) {
      this.pacienteSelecionado = { ...value };
      setTimeout(() => {
        this.encontrado = true;
      }, 1);
    },
  },
  created() {},
};
</script>

<style scoped>
.icons-list {
  font-size: 30px;
  margin-left: 38%;
}

.col-icon {
  transition: transform 0.2s;
  cursor: pointer;
}

.col-icon:hover {
  transform: scale(1.1);
}

.icons-list:hover {
  color: #03315f;
  text-shadow: 0 0 3px #03315f;
}

.horizontal-center {
  margin: 0 auto;
}
</style>
